import axios from "./axios";

export const getPartners = () => axios.get().get(`/partners`)
